import { CtgListTotalData } from "@interface/ctgList.interface";

export const adaptCTGListData = (responseData: CtgListTotalData) => {
  return {
    ...responseData,
    data: responseData.data.map((info) => {
      return {
        ...info,
        organizationName: info.organizationName || [],
      };
    }),
  };
};
